module.exports = __webpack_public_path__ + "static/media/invest_goal.e02f3c82.svg";